export const playingBar = {
  'Now playing view': 'Estás escuchando',
  Lyrics: 'Letras',
  Queue: 'Fila de reproducción',
  'Connect to a device': 'Conectar a un dispositivo',
  Mute: 'Silenciar',
  Unmute: 'Activar sonido',
  'Full Screen': 'Expandir pantalla',
  Home: 'Inicio',
  'Source code': 'Código fuente',
  'Your Library': 'Tu biblioteca',
  'Now playing': 'Reproduciendo',
  Next: 'A continuación',
  Description: 'Descripción',
  'About the artist': 'Acerca del artista',
  Search: 'Buscar',
  Images: 'Imágenes',
  Devices: 'Dispositivos',
  followers: 'seguidores',
  'Next in queue': 'A continuación',
  'Open Queue': 'Abrir fila',
  'Select another device': 'Seleccionar otro dispositivo',
  'Current device': 'Dispositivo actual',
  'Related projects': 'Proyectos relacionados',
  'Exit full screen': 'Salir de pantalla completa',
  'Failed to transfer playback': 'Error al transferir la reproducción',
};
